import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=593d9dd0&scoped=true"
var script = {}
import style0 from "./Features.vue?vue&type=style&index=0&id=593d9dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593d9dd0",
  null
  
)

export default component.exports